import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  inlineSeparator: {
    [`${theme.breakpoints.up('lg')}`]: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
    },
  },
}));

const InlineSeparator = () => {
  const classes = useStyles();

  return <span className={classes.inlineSeparator}>-</span>;
};

export default InlineSeparator;
